/* eslint-disable @typescript-eslint/ban-types */
/**
 * All components on mono-frontend  needs to implements this interface
 * This contribute to reach the tslint rule max-file-count
 * Each component needs to have at least one of this properties
 * param ConfigT: Pass component configurations
 * param ContentT: Pass the content which component Need
 * param StylesT: Pass any styles for component
 * param NotificationsT: Pass any error/warning/success message object to component
 */

import { UntypedFormGroup } from '@angular/forms';

export interface BaseProperties<
  ConfigT = {},
  ContentT = {},
  StylesT = {},
  NotificationsT = {}
> {
  config?: ConfigT;
  content?: ContentT;
  styles?: StylesT;
  notifications?: NotificationsT;
}

/** generic interface to have common interfaces to define data into aem & bff category */
export interface StateGeneric<AemT = {}, BffT = {}> {
  aem?: AemT;
  bff?: BffT;
}

export interface UlItem {
  id?: string;
  value?: string;
  label?: string;
  codeKey?: number | string;
  type?: string;
  defaultValueSet?: boolean;
  formData?: UntypedFormGroup;
  icon?: string;
  secondaryIcon?: string;
  additionalIcon?: string;
  displayName?: string;
  index?: number;
}

export interface Message {
  icon: string;
  label: string;
  description: string;
}

export interface SimpleBlock {
  header: string;
  message: Partial<Message>;
  subHeader?: string;
}

export interface HelpModal {
  icon: boolean;
  title: string;
  content: string;
  closeLabel?: string;
  type: string;
  tooltip?: boolean;
  modalStyle?: string;
  closeOnBackgroundClick?: boolean;
  hideCloseButton?: boolean;
}

export interface Config {
  [key: string]: string;
}

export interface Image {
  alt: string;
  src: string;
  show?: boolean;
}

export interface Phone {
  areaCode?: string;
  countryCode?: string;
  countryNumber?: string;
  deviceType?: string;
  extension?: string;
  id?: string;
  isPrimary?: boolean;
  location?: string;
  phoneNumber?: string;
  phoneType?: string;
}

export interface MedallionEntityInterface {
  medallionId?: string;
  medallionLabel?: string;
  medallionUrl?: string;
  medallionMessage?: string;
}

export interface PassengersEntityInterface {
  passengerId?: string;
  passengerTitle?: string;
}

export interface LabelAndValue {
  label: string;
  value?: string;
  isGroup?: boolean;
}

export interface LabelAndImage {
  label: string;
  image: Image;
}

export interface UserNameAndValue {
  username?: string;
  value?: string;
}

export interface SkymilesAndValue {
  skymiles?: string;
  value?: string;
}

export interface ElementFocus {
  active: boolean;
  index?: number;
}

export interface UIFormEvent {
  target: HTMLInputElement;
  key: string;
}

export interface FieldItem {
  id: string;
  value: string;
}

export interface GeneralStyleObject {
  height: number;
  marginBottom: number;
  marginLeft: number;
  marginRight: number;
  marginTop: number;
  width: number;
}

export interface CheckboxValue {
  id?: string;
  value: boolean;
}
